import React from 'react'
import { useTranslation } from 'react-i18next'
import { TooltipList } from 'packages/ui/Graph'
import { CustomTooltipProps } from '../../../../utils/types'
import { PING_COLOR } from '../../../../utils/constants'

const LatencyTooltip: React.FC<CustomTooltipProps> = ({ active, label, payload }) => {
  const { t } = useTranslation()
  if (!active || !payload || !payload.length) return null

  const ping = payload.find(({ dataKey }) => dataKey === 'ping')
  const pingValue = typeof ping?.value === 'number' ? ping.value : 0
  const dataPoint = payload[0]?.payload

  return (
    <TooltipList
      title={dataPoint?.formattedTime || label}
      list={[
        {
          color: PING_COLOR,
          label: t('wan.graphs.latency.ping'),
          value: `${(pingValue * 1000).toFixed(2)} ms`
        },
      ]}
    />
  )
}

export default LatencyTooltip
